module.exports = __webpack_public_path__ + "img/453-12db19.png";